import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Icon, LinkButton, Spinner, theme } from '@salecycle/ui-component-library';
import { ConsentFileType } from '../types';

type Props = {
  fileType: ConsentFileType;
  filesToProcess?: number;
  disabled?: boolean;
};

const Container = styled.div`
  border: 1px dashed ${theme.vars.color.grey2};
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 2.2rem;
  align-items: center;
  /* impacts icon sizing */
  font-size: 1.3rem;

  svg {
    margin-bottom: 2.5rem;
  }
`;

const SpinnerContainer = styled.div`
  margin-bottom: 2.5rem;
  margin-top: 1.2rem;
`;

const Header = styled.h4`
  margin-bottom: 2.5rem;
`;

const Description = styled.div`
  font-size: 1.6rem;
  margin-top: 1rem;

  button {
    font-size: 1.6rem;
  }

  small {
    display: block;
    color: ${theme.vars.newColor.darkGS2};
    margin-top: 1rem;
    font-size: 1.4rem;
  }
`;

export function ConsentDropArea({ fileType, disabled, filesToProcess }: Props) {
  const { t } = useTranslation('fileManagement');
  const isProcessing = filesToProcess > 0;

  return (
    <Container>
      <Header>{t(`analysis.dropArea.title.${fileType}`)}</Header>
      {!disabled && (
        <>
          {isProcessing && (
            <SpinnerContainer data-testid="SpinnerContainer">
              <Spinner size="large" />
            </SpinnerContainer>
          )}
          {!isProcessing && <Icon icon="file-upload" size="4x" color={theme.vars.newColor.lightGS1} />}
          <Description>
            {isProcessing && t('analysis.dropArea.processing', { filesToProcess })}
            {!isProcessing && (
              <>
                {t('analysis.dropArea.description')}&nbsp;
                <LinkButton>{t('analysis.dropArea.buttonLabel')}</LinkButton>
              </>
            )}
            <small>{t('analysis.dropArea.supports')}</small>
          </Description>
        </>
      )}
    </Container>
  );
}
